import React, { useMemo, useState } from "react";

function splitDisplayName(displayName = "") {
  const parts = String(displayName).trim().split(/\s+/).filter(Boolean);
  return {
    firstName: parts[0] || "",
    lastName: parts.slice(1).join(" "),
  };
}

export default function CompleteProfileModal({ user, userDoc, onSave }) {
  const initial = useMemo(() => {
    const parsed = splitDisplayName(userDoc?.displayName || user?.displayName || "");
    return {
      firstName: userDoc?.firstName || parsed.firstName,
      lastName: userDoc?.lastName || parsed.lastName,
      dateOfBirth: userDoc?.dateOfBirth || "",
    };
  }, [user, userDoc]);

  const [form, setForm] = useState(initial);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const setField = (key) => (event) =>
    setForm((current) => ({ ...current, [key]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setSaving(true);
    try {
      await onSave(form);
    } catch (err) {
      setError(err?.message || "Unable to save your profile.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "#07111f" }}>
      <form onSubmit={submit} style={{ width: "min(520px, 100%)", padding: 28, borderRadius: 22, background: "#111c2e", border: "1px solid #29405f", color: "#f8fafc", boxShadow: "0 24px 80px rgba(0,0,0,.35)" }}>
        <div style={{ color: "#67d5ff", fontWeight: 900, letterSpacing: 1.8, fontSize: 12 }}>PLAYSWITHGURU</div>
        <h1 style={{ margin: "8px 0 8px", fontSize: 30 }}>Welcome to PWG</h1>
        <p style={{ margin: "0 0 24px", color: "#b8c5d9", lineHeight: 1.55 }}>
          Tell us your name so we can personalize your experience. Birthday is optional.
        </p>

        <label style={labelStyle}>First name *</label>
        <input autoFocus required value={form.firstName} onChange={setField("firstName")} style={inputStyle} />

        <label style={labelStyle}>Last name *</label>
        <input required value={form.lastName} onChange={setField("lastName")} style={inputStyle} />

        <label style={labelStyle}>Date of birth <span style={{ opacity: .65 }}>(optional)</span></label>
        <input type="date" value={form.dateOfBirth} onChange={setField("dateOfBirth")} style={inputStyle} />
        <div style={{ color: "#8fa2bc", fontSize: 12, marginTop: -6, marginBottom: 18 }}>
          You may leave this blank. PWG will not block access when DOB is missing.
        </div>

        {error && <div role="alert" style={{ padding: 12, borderRadius: 10, background: "rgba(190,24,93,.18)", color: "#fecdd3", marginBottom: 14 }}>{error}</div>}

        <button disabled={saving} type="submit" style={{ width: "100%", padding: "14px 18px", border: 0, borderRadius: 12, background: "#2563eb", color: "white", fontWeight: 900, fontSize: 16, cursor: saving ? "wait" : "pointer", opacity: saving ? .7 : 1 }}>
          {saving ? "Saving…" : "Continue to PlaysWithGuru"}
        </button>
        <div style={{ marginTop: 14, color: "#8fa2bc", fontSize: 12, textAlign: "center" }}>{user?.email || ""}</div>
      </form>
    </div>
  );
}

const labelStyle = { display: "block", fontSize: 13, fontWeight: 850, margin: "14px 0 7px", color: "#dbeafe" };
const inputStyle = { width: "100%", boxSizing: "border-box", padding: "13px 14px", borderRadius: 11, border: "1px solid #3a4e6a", background: "#0b1525", color: "#f8fafc", fontSize: 16, outline: "none" };
